import { WrapperGS, WrapperValued } from '../core/WrapperGS';

export class InputGS extends WrapperGS<HTMLInputElement> implements WrapperValued
{
    static ForHTMLElement(el: HTMLElement): boolean {
        if (el.nodeName.toLowerCase() === 'input') {
            const inputEl = el as HTMLInputElement;
            return inputEl.type !== 'file';
        }
        return false;
    }

    constructor(el: HTMLInputElement | string) {
        super(el);
    }

    public get value() { return this.el.value; }
    public set value(value: string) { this.el.value = value; }
}

WrapperGS.ExtendComponentsByHTMLElement(InputGS);
